import React, { useEffect, useState } from "react";
import styles from "./Menu.module.css";
import MenuTab from "./MenuTab";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import IncidentMenuTab from "./IncidentMenuTab";
import EagleILogo from "../../assets/Eagle_I_Logo.png";
import EarlyWarningItem from "./EarlyWarningItem";
import Draggable from "react-draggable";
import { LayoutProvider,useLayout  } from '../../layout/LayoutContext';
import { openEwsWindowsMap } from "../../mainLayer/earlyWarning/ShowEarlyWarning";

type MenuPropsType = {
  popupLayerType: string;
  passStartDurationForm: (from: string) => void;
  passFromDurationTo: (to: string) => void;
  endTime: string;
  playTimer: boolean;
  showTimeRangeNotification: (show: boolean) => void;
  closePopupDropDown: (open: boolean) => void;
  passClickedHzIncidentMapValue: (clicked: boolean) => void;
  addLayerPopup: (open: boolean) => void;
  layerValueFromMainMenu: (value: string) => void;
  passClickedEWSValue: (clicked: boolean) => void;
  timeLineHour: string;
  timeLineDate: string;
  openLayerTypeMap: Map<string, boolean>;
  sensorType: (value: string) => void;
  openModular: (value: string) => void;
  renderEWS: (value: boolean) => void;
  renderHz: (value: boolean) => void;
};

let openTitle: string = "";

const layerDetails = [
  {
    id: 1,
    title: "Landslides",
    img: "",
  },
  {
    id: 2,
    title: "Flood",
    img: "",
  },
  {
    id: 3,
    title: "Heavy Rain & Thunderstorm",
    img: "",
  },
  {
    id: 4,
    title: "Severe Lightning",
    img: "",
  },
  {
    id: 5,
    title: "Rough Sea",
    img: "",
  },
];

const overlayDetails = [
  {
    id: 1,
    title: "Landslide Early Warning",
    img: "../../assets/img.jpg",
  },
  {
    id: 2,
    title: "Flood Early Warning",
    img: "../../assets/img.jpg",
  },
  {
    id: 3,
    title: "Heavy Rain Early Warning",
    img: "../../assets/img.jpg",
  },
  {
    id: 4,
    title: "High Wind Warning",
    img: "../../assets/img.jpg",
  },
  {
    id: 5,
    title: "Severe Lightning Early Waring",
    img: "../../assets/img.jpg",
  },
  {
    id: 6,
    title: "Marine Early Waring",
    img: "../../assets/img.jpg",
  },
  {
    id: 7,
    title: "Tsunami Early Waring",
    img: "../../assets/img.jpg",
  },
];

const basecampDetails = [
  {
    id: "1",
    title: "Satellite 1",
  },
  {
    id: "2",
    title: "Satellite 2",
  },
  {
    id: "3",
    title: "Satellite 3",
  },
];

const MainLayerPopup = ({
  popupLayerType,
  passStartDurationForm,
  passFromDurationTo,
  endTime,
  playTimer,
  showTimeRangeNotification,
  closePopupDropDown,
  passClickedHzIncidentMapValue,
  addLayerPopup,
  layerValueFromMainMenu,
  passClickedEWSValue,
  timeLineHour,
  timeLineDate,
  openLayerTypeMap,
  sensorType,
  openModular,
  renderEWS,
  renderHz,
  
}: MenuPropsType) => {
  let [isMenuOpen, setIsMenuOpen] = useState<boolean>(true);
  const [openTab, setOpenTab] = useState<number | null>(null);
  const { layout } = useLayout();

  const toggleDropDown = () => {

    const hasOpenValue = Array.from(openEwsWindowsMap.values()).some(
      (value) => value === "open"
    );

    closePopupDropDown(false);
    layerValueFromMainMenu("main");
    openTitle="";
  };

  const handleAddLayerPopup = () => {
    addLayerPopup(true);
  };

  const [incidentTabOpen, setIncidentTabOpen] = useState(false);
  const [earlyWarningTabOpen, setEarlyWarningTabOpen] = useState(false);
  const [satelliteTabOpen, setSatelliteTabOpen] = useState(false);

  useEffect(() => {
    // Convert the Map to an array to force re-render on any change in the Map
    const openLayerTypeMapEntries = Array.from(openLayerTypeMap.entries());
  
    const updatedTrueKeys = new Set<string>();
    openLayerTypeMapEntries.forEach(([key, value]) => {
      if (value === true) {
        if (key === "earlywarning") {
          updatedTrueKeys.add("ews");
        } else if (key === "hzIncidents") {
          updatedTrueKeys.add("incd");
        } else if (key === "satellite not") {
          updatedTrueKeys.add("satellite");
        }
      }
    });
  
      // setIncidentTabOpen(updatedTrueKeys.has("incd"));
      // setEarlyWarningTabOpen(updatedTrueKeys.has("ews"));
      // setSatelliteTabOpen(updatedTrueKeys.has("satellite"));
 
  }, [Array.from(openLayerTypeMap.entries()), layout]);

  useEffect(() => {
    // if(popupLayerType==="Reported Incidents"){
    //   openTitle="Reported Incidents";
    //   setIncidentTabOpen(true)
    //   setEarlyWarningTabOpen(false)
    //   setSatelliteTabOpen(false)
    // }else if(popupLayerType==="Early Warnings"){
    //   openTitle="Early Warnings";
    //   setIncidentTabOpen(false)
    //   setEarlyWarningTabOpen(true)
    //   setSatelliteTabOpen(false)
    // }else if(popupLayerType==="Satellite Imagery"){
    //   openTitle="Satellite Imagery";
    //   setIncidentTabOpen(false)
    //   setEarlyWarningTabOpen(false)
    //   setSatelliteTabOpen(true)
    // }
  }, [popupLayerType]);

  // useEffect(() => {}, [incidentTabOpen]);
  // useEffect(() => {}, [earlyWarningTabOpen]);
  // useEffect(() => {}, [satelliteTabOpen]);


  return (
    <div>
      <Draggable handle=".drag-handle" enableUserSelectHack={false}>
        <div className="drag-handle">
          <div className={styles.menuContainer}>
            <div className={styles.titleContainer}>
              {/* <span>Eagle-I</span> */}

              <img src={EagleILogo} width={"10%"} height={"10%"} />
            </div>
          
            {/* {
              layout==="hawk eye" && (  <div
              className={styles.tabContainer}
              style={{
                display: `${isMenuOpen ? "flex" : "none"}`,
              }}
            >
              <IncidentMenuTab
                id={1}
                title="Reported Incidents"
                type="layer"
                itemDetails={layerDetails}
                popupLayerType={popupLayerType}
                passStartDurationForm={passStartDurationForm}
                passFromDurationTo={passFromDurationTo}
                endTime={endTime}
                playTimer={playTimer}
                showTimeRangeNotification={() => {
                  showTimeRangeNotification(true);
                }}
                setOpenTab={setOpenTab}
                openTabId={openTab}
                passClickedHzIncidentMapValue={passClickedHzIncidentMapValue}
                timeLineHour={timeLineHour}
                timeLineDate={timeLineDate}
                sensorType={sensorType} openModular={openModular} renderHz={renderHz}
              />  
             
                <EarlyWarningItem
                  id={2}
                  title="Early Warnings"
                  type="overlay"
                  itemDetails={overlayDetails}
                  popupLayerType={popupLayerType}
                  setOpenTab={setOpenTab}
                  openTabId={openTab}
                  passClickedEWSValue={passClickedEWSValue}
                  sensorType={sensorType} openModular={openModular} renderEWS={renderEWS}
                />
              
                <MenuTab
                  id={3}
                  title="Satellite Imagery"
                  type="basecamp"
                  itemDetails={basecampDetails}
                  popupLayerType={popupLayerType}
                  setOpenTab={setOpenTab}
                  openTabId={openTab}
                />
                <MenuTab
                  id={4}
                  title="Projection"
                  type="projection"
                  itemDetails={projectionDetails}
                  popupLayerType={popupLayerType}
                  setOpenTab={setOpenTab}
                  openTabId={openTab}
                />
            </div>  )
            } */}
          <div
              className={styles.tabContainer}
              style={{
                display: `${isMenuOpen ? "flex" : "none"}`,
              }}
            >
                 {popupLayerType==="Reported Incidents" && ( <IncidentMenuTab
                id={1}
                title="Reported Incidents"
                type="layer"
                itemDetails={layerDetails}
                popupLayerType={popupLayerType}
                passStartDurationForm={passStartDurationForm}
                passFromDurationTo={passFromDurationTo}
                endTime={endTime}
                playTimer={playTimer}
                showTimeRangeNotification={() => {
                  showTimeRangeNotification(true);
                }}
                setOpenTab={setOpenTab}
                openTabId={openTab}
                passClickedHzIncidentMapValue={passClickedHzIncidentMapValue}
                timeLineHour={timeLineHour}
                timeLineDate={timeLineDate}
                sensorType={sensorType} openModular={openModular} renderHz={renderHz}
              />   )}
                   {popupLayerType==="Early Warnings" && (
                <EarlyWarningItem
                  id={2}
                  title="Early Warnings"
                  type="overlay"
                  itemDetails={overlayDetails}
                  popupLayerType={popupLayerType}
                  setOpenTab={setOpenTab}
                  openTabId={openTab}
                  passClickedEWSValue={passClickedEWSValue}
                  sensorType={sensorType} openModular={openModular} renderEWS={renderEWS}
                />
              )}
                 {popupLayerType==="Satellite Imagery" && (
                <MenuTab
                  id={3}
                  title="Satellite Imagery"
                  type="basecamp"
                  itemDetails={basecampDetails}
                  popupLayerType={popupLayerType}
                  setOpenTab={setOpenTab}
                  openTabId={openTab}
                  timeLineHour={timeLineHour}
                  timeLineDate={timeLineDate}
                />
              )}
                {/* <MenuTab
                  id={4}
                  title="Projection"
                  type="projection"
                  itemDetails={projectionDetails}
                  popupLayerType={popupLayerType}
                  setOpenTab={setOpenTab}
                  openTabId={openTab}
                /> */}
            </div>  
            <div className={styles.buttonContainer}>
              <div className={styles.cell} style={{ gridArea: "a" }}>
                <FontAwesomeIcon size="1x" icon={faLayerGroup} color="white" />
                <div
                  style={{
                    marginLeft: "10px",
                    cursor: `pointer`,
                  }}
                  onClick={handleAddLayerPopup}
                  onTouchStart={handleAddLayerPopup}
                >
                  <span>Add Layers +</span>
                </div>
              </div>
              <div
                className={styles.cell}
                style={{
                  gridArea: "b",
                  backgroundColor: "#3452eb",
                  cursor: `pointer`,
                  marginRight: `10px`,
                }}
                onClick={toggleDropDown}
                onTouchStart={toggleDropDown}
              >
                <span>Close</span>
                <div
                  style={{
                    marginLeft: "10px",
                  }}
                >
                  <FontAwesomeIcon size="1x" icon={faClose} color="white" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Draggable>
    </div>
  );
};

export default MainLayerPopup;
